import { X } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';

const Paylines = ({ lineForBet, setLineForBet, onClose }) => {
  const { data, loading } = useSelector((state) => state.gameSettings);
  const payLines = data?.slotConfigDetails?.paylines || [];
  const progress = (lineForBet / payLines.length) * 100;

  if (loading) return <div className="text-white text-2xl text-center pt-5">Loading...</div>;
  if (!data) return <div className="text-white text-2xl text-center pt-5">No game data available</div>;

  if (payLines.length === 0) {
    return (
      <>
        <div className="py-3 text-2xl sm:text-3xl xl:text-5xl font-bold text-white">Pay Lines</div>
        <div className="text-white text-2xl text-center pt-5">No Pay Lines Found!</div>
      </>
    );
  }

  return (
    <div className="h-full w-full flex flex-col items-center text-gray-50">
      <button
        className="absolute top-1 right-1 sm:top-2 sm:right-2 lg:top-4 lg:right-4 text-gray-50 bg-slate-700 p-1 hover:text-gray-300 text-xl rounded-full"
        onClick={onClose}
      >
        <X className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 md:w-4 md:h-4 lg:w-7 lg:h-7 2xl:w-9 2xl:h-9 3xl:w-12 3xl:h-12" />
      </button>
      <div className="xs:text-lg sm:text-lg md:text-2xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-5xl h-[15%] w-full text-center text-gray-50 font-bold border-b-gray-200 border-b-[0.05px] flex items-center justify-center">
        Lines
      </div>

      <div className="w-full h-full flex flex-col items-center justify-start">

        {/* Buttons aligned properly */}
        <div className="grid grid-cols-5 xs:gap-1 md:gap-3 w-full h-[60%] max-w-[50%] mt-4 mx-auto place-items-center justify-center">
          {payLines.map((payline) => (
            <button
              key={payline._id}
              className={`xs:px-3 md:px-6 xs:py-1 md:py-3 rounded-lg shadow-lg 
                            uppercase tracking-widest font-extrabold text-gray-700
                            text-xs sm:text-sm md:text-base xl:text-2xl 2xl:text-3xl
                            xs:w-10 xs:h-6 md:h-8 lg:w-16 lg:h-12 xl:w-20 xl:h-12 2xl:w-24 2xl:h-16 3xl:w-36 3xl:h-20
                            flex items-center justify-center
                            ${lineForBet === payline.id
                  ? "bg-[#F8B731]"
                  : "bg-white border border-gray-400 hover:bg-[#F8B731]"
                }`}
              onClick={() => setLineForBet(payline.id)}
            >
              {payline.id}
            </button>
          ))}
        </div>

        {/* Range Bar */}
        <div className="flex flex-col items-center w-full mt-1 max-w-[50%] xs:text-md md:text-lg lg:text-xl 2xl:text-2xl 3xl:text-4xl">
          <div className="flex items-center justify-between w-full mb-2 px-2.5">
            <span className="font-semibold">Lines</span>
            <span className="font-semibold">{lineForBet}</span>
          </div>
          <input
            type="range"
            min="0"
            max={payLines.length}
            value={lineForBet}
            onChange={(e) => setLineForBet(Number(e.target.value))}
            className="w-full h-2 rounded-lg appearance-none cursor-pointer transition-all"
            style={{
              background: `linear-gradient(to right, #F8B731 ${progress}%, white ${progress}%)`,
              borderRadius: "5px",
              height: "8px",
            }}
          />
          <style>
            {`
                  input[type="range"]::-webkit-slider-thumb {
                      appearance: none;
                      width: 16px;
                      height: 16px;
                      background: #F8B731;
                      border-radius: 50%;
                      cursor: pointer;
                      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
                  }

                  input[type="range"]::-moz-range-thumb {
                      width: 16px;
                      height: 16px;
                      background: #F8B731;
                      border-radius: 50%;
                      cursor: pointer;
                      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
                  }
              `}
          </style>
        </div>
      </div>
    </div>
  );
};

export default Paylines;